import { cn } from "../lib/classNames";

interface Props {
  years: number[];
  size?: "sm" | "md";
}

export function SelectionBadges({ years, size = "md" }: Props) {
  if (years.length === 0) return null;
  const cls =
    size === "sm" ? "px-1.5 py-0.5 text-[10px]" : "px-2 py-0.5 text-xs";
  return (
    <div className="flex flex-wrap gap-1">
      {years.map((y) => (
        <span
          key={y}
          className={cn(
            "rounded-md bg-amber-500/15 font-mono font-semibold text-amber-200 ring-1 ring-inset ring-amber-400/30",
            cls,
          )}
        >
          {y}
        </span>
      ))}
    </div>
  );
}
